import { useMemo } from 'react';
import { useJiraServiceManagementProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { usePageContext } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/page-context/main.tsx';
import type { UseQueueFeaturesReturn } from './types.tsx';

export const useQueueFeatures = (): UseQueueFeaturesReturn => {
	const [{ data: pageContextData, error: pageContextError }] = usePageContext();
	const { projectContext, tenantContext } = pageContextData || {};
	const canMoveQueues = !pageContextError
		? projectContext?.isAdmin || tenantContext?.isSiteAdmin
		: false;
	const canManageQueues = !pageContextError ? projectContext && projectContext.isAdmin : false;
	const { data } = useJiraServiceManagementProjectNavigation();
	const hasNewQueueItemV4Nav = useMemo(() => data && data.isAdminAgent, [data]);
	return {
		canMoveQueues: Boolean(canMoveQueues),
		hasNewQueueItem: Boolean(hasNewQueueItemV4Nav),
		canManageQueues: Boolean(canManageQueues),
	};
};
